import { Section, Subsections } from 'utils/types/contentfulTypes';

import { getMobileAndDesktopFirstImage } from '../utils';
import { InteractiveBannerProps } from './InteractiveBanner';

export const parseInteractiveBanner = (
  contentfulSection: Section,
): InteractiveBannerProps | null => {
  const { eyebrow, images, subsections } = contentfulSection;
  const { title, theme, ctas, order } = contentfulSection.metadata || {};

  // @ts-ignore
  const { desktopImage } = getMobileAndDesktopFirstImage(images);

  // The Interactive component can have a Slider (WeightLossSlider component) or a form (LearnMoreForm) subsection
  type SubsectionComponents = {
    isSlider: Subsections[];
    isForm: Subsections[];
  };

  const initialSubsections: SubsectionComponents = {
    isSlider: [],
    isForm: [],
  };

  const { isSlider, isForm } =
    subsections?.reduce<SubsectionComponents>((component, item) => {
      switch (item?.componentName) {
        case 'WeightLossSlider':
          component.isSlider.push(item);
          break;
        case 'LearnMoreForm':
          component.isForm.push(item);
          break;
      }
      return component;
    }, initialSubsections) ?? initialSubsections;

  const mapLearnMoreForm = (item: Subsections) => ({
    eyebrow: item?.eyebrow || '',
    metadata: {
      title: item?.metadata?.title || '',
      theme: {
        backgroundColor:
          item?.metadata?.theme?.backgroundColor || 'eggplant.light',
        textColor: item?.metadata?.theme?.textColor || 'tints.black',
        primaryColor: item?.metadata?.theme?.primaryColor || 'viridian.light',
      },
      order: item?.metadata?.order || 1,
    },
  });

  const mapWeightLossSlider = (item: Subsections) => ({
    eyebrow: item?.eyebrow || '',
    body: {
      raw: item?.body?.raw || '',
    },
    desktopImage: item?.images[0].desktopImage || '',
    metadata: {
      title: item?.metadata?.title || '',
      context: {
        calculation: {
          percentage: item?.metadata?.context?.calculation?.percentage || 0,
        },
      },
      theme: {
        backgroundColor:
          item?.metadata?.theme?.backgroundColor || 'eggplant.lighter',
        textColor: item?.metadata?.theme?.textColor || 'eggplant.light',
        primaryColor: item?.metadata?.theme?.primaryColor || 'violet.dark',
      },
      order: item?.metadata?.order || 1,
    },
  });

  const learnMoreForm = isForm.map(mapLearnMoreForm);
  const weightLossSlider = isSlider.map(mapWeightLossSlider);

  return {
    eyebrow,
    title,
    desktopImage,
    theme: {
      backgroundColor: theme?.backgroundColor || 'tints.lightCream',
      textColor: theme?.textColor || 'tints.black',
      primaryColor: theme?.primaryColor || 'violet.dark',
    },
    cta: {
      label: ctas?.[0]?.label || '',
      url: ctas?.[0]?.url || '',
    },
    order,
    weightLossSlider,
    learnMoreForm,
  };
};
